import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addPurchaseCart, clearError, clearMessage } from "../redux/manageProductSlice";
import { ToastContainer, toast } from "react-toastify";

const PurchaseProductModal = ({ visible, onCancel, product }) => {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const [unitsInPack, setUnitsInPack] = useState(product.unitsInPack);
  const [purchasePricePack, setPurchasePricePack] = useState(product.purchasePricePack);
  const [purchasePriceUnit, setPurchasePriceUnit] = useState(product.purchasePriceUnit);
  const [sellingPricePack, setSellingPricePack] = useState(product.sellingPricePack);
  const [sellingPriceUnit, setSellingPriceUnit] = useState(product.sellingPriceUnit);
  
  const { loading, error, message } = useSelector((state) => state.manageProduct);

  const confirmSellProduct = () => {
    const stockData = {
      product_id: product.id,
      quantity,
      unitsInPack,
      purchasePricePack,
      purchasePriceUnit,
      sellingPricePack,
      sellingPriceUnit,
    };
    dispatch(addPurchaseCart(stockData));
    onCancel();
  };

  useEffect(() => {
    if (error) {
      toast(error);
      setTimeout(() => {
        dispatch(clearError());
      }, 3000);
    }
    if (message) {
      toast(message);
      setTimeout(() => {
        dispatch(clearMessage());
      }, 3000);
    }
  }, [error, dispatch, message]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
         <ToastContainer/>
      <div className="bg-white p-8 rounded-lg w-full max-w-2xl" onClick={e => e.stopPropagation()}>
        <div className="text-center mb-6">
          <h2 className="text-lg font-semibold">Purchase {product.productName}</h2>
          <p className="text-gray-600 mt-2">Enter quantity and new price</p>
          <p className="text-gray-600 mt-2">Stock: {product.packStock}.{product.unitStock} qty</p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-gray-700 block mb-2">Quantity</label>
            <input
              type="number"
              value={quantity || ''}
              onChange={(e) => setQuantity(Number(e.target.value))}
              placeholder="Enter quantity"
              className="border p-3 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="text-gray-700 block mb-2">Units per Pack</label>
            <input
              type="number"
              value={unitsInPack?.toString() || ''}
              onChange={(e) => setUnitsInPack(Number(e.target.value))}
              placeholder="Enter units per pack"
              className="border p-3 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mt-4">
          <div>
            <label className="text-gray-700 block mb-2">Purchase Price (Pack)</label>
            <input
              type="number"
              value={purchasePricePack || ''}
              onChange={(e) => setPurchasePricePack(Number(e.target.value))}
              placeholder="Enter price per pack"
              className="border p-3 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="text-gray-700 block mb-2">Purchase Price (Unit)</label>
            <input
              type="number"
              value={purchasePriceUnit || ''}
              onChange={(e) => setPurchasePriceUnit(Number(e.target.value))}
              placeholder="Enter price per unit"
              className="border p-3 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mt-4">
          <div>
            <label className="text-gray-700 block mb-2">Selling Price (Pack)</label>
            <input
              type="number"
              value={sellingPricePack || ''}
              onChange={(e) => setSellingPricePack(Number(e.target.value))}
              placeholder="Enter selling price per pack"
              className="border p-3 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="text-gray-700 block mb-2">Selling Price (Unit)</label>
            <input
              type="number"
              value={sellingPriceUnit || ''}
              onChange={(e) => setSellingPriceUnit(Number(e.target.value))}
              placeholder="Enter selling price per unit"
              className="border p-3 w-full rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>

        <div className="flex justify-center gap-4 mt-8">
          <button
            onClick={onCancel}
            className="px-6 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={confirmSellProduct}
            className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            {loading ? "Loading..." : "Confirm"}
          </button>
        </div>

        <div className="border-t-2 border-gray-200 mt-6 pt-4">
          <div className="grid grid-cols-4 gap-4 mb-2 font-semibold text-sm">
            <div>Name</div>
            <div>Quantity</div>
            <div>Price/Unit</div>
            <div>Total</div>
          </div>
          <div className="grid grid-cols-4 gap-4 text-sm">
            <div>{product.productName}</div>
            <div>{quantity}</div>
            <div>{purchasePricePack}</div>
            <div>{quantity * purchasePricePack}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseProductModal;